import consultRequestCreator from '../../consultRequestCreator';
import urlConstants from '../../../constants/urlConstants.js';

export function fetchProblemAreasForQuery(id, type) {
  return consultRequestCreator
    .get(urlConstants.SPECIALITY, { params: { id, type } })
    .then(({ data }) => data.specialities.map(speciality => speciality.id));
}
